import { useEffect, useState } from "react";
import { Typography, Box, Link, Alert, Grid, Fade } from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router";

const NotFound = () => {
  const [fadeIn, setFadeIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setFadeIn(true);
  }, []);

  return (
    <Fade in={fadeIn}>
      <Grid
        sx={{ width: "100vw", height: "100vh", overflow: "auto" }}
        container
      >
        <Grid
          size={{ sm: 12, md: 6 }}
          sx={{ display: "flex", alignItems: "center", p: 2 }}
        >
          <Box
            sx={{
              maxWidth: 350,
              mx: "auto",
              textAlign: "center",
              "& .MuiOutlinedInput-input": {
                p: "4.5px 14px",
              },
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
              },
              "& .MuiTextField-root": {
                mt: 0,
              },
              "& .MuiButton-root": {
                borderRadius: 0,
                p: "2.75px 15px",
              },
            }}
          >
            <img src="/logo.png" height="80px" alt="Logo" />
            <Typography variant="h4" sx={{ fontSize: 24 }} gutterBottom>
              404 - Page Not Found
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: 15, mb: 2 }}
              gutterBottom
            >
              The page you are looking for does not exist
            </Typography>

            <Alert severity="error" sx={{ mt: 2, textAlign: "left" }}>
              The page you are looking for does not exist.
            </Alert>

            <Box
              sx={(theme) => ({
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 3,
                "& a, button": {
                  fontSize: 14,
                  color: theme.palette.primary.main,
                },
              })}
            >
              <Link
                component="button"
                onClick={() => navigate(-1)}
                style={{
                  textDecoration: "none",
                  fontWeight: "bold",
                  fontFamily: "Brandon_Grotesque_bold",
                }}
              >
                Go Back
              </Link>
              <Link
                component={RouterLink}
                to="/login"
                style={{
                  textDecoration: "none",
                  fontWeight: "bold",
                  fontFamily: "Brandon_Grotesque_bold",
                }}
              >
                Go to Login
              </Link>
            </Box>
          </Box>
        </Grid>
        <Grid
          size={{ sm: 12, md: 6 }}
          sx={{
            display: { xs: "none", md: "block" },
            height: "100vh",
            overflow: "hidden",
            borderRadius: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              style={{
                height: "100vh",
                width: "100%",
                objectFit: "cover",
                objectPosition: "center",
                display: "block",
              }}
              src="/login_img.jpg"
              alt="Background"
            />
          </Box>
        </Grid>
      </Grid>
    </Fade>
  );
};

export default NotFound;
